import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService, AppUser } from '../../services/auth.service';
import { Subscription } from 'rxjs';
import { TenantRouterService } from '../../services/tenant-router.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: false,
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {

  userName: string = 'Profile';
  personType: 'user' | 'manager' | 'hr' = 'user';
  private subscription!: Subscription;

  constructor(
    private authService: AuthService,
    private tenantRouter: TenantRouterService
  ) {}

  ngOnInit(): void {
    this.subscription = this.authService.currentUser$.subscribe(
      (user: AppUser | null) => {
        if (user) {
          this.userName = user.Name;
          this.personType = user.personType;
        }
      }
    );
  }

  /** Dashboard navigation (role-based) */
  goToDashboard(): void {
    switch (this.personType) {
      case 'manager':
        this.tenantRouter.navigate('manager-dashboard');
        break;
      case 'hr':
        this.tenantRouter.navigate('hr-dashboard');
        break;
      default:
        this.tenantRouter.navigate('user-dashboard');
    }
  }

  /** Generic tenant-safe navigation */
  goToLinkRoute(route: string): void {
    this.tenantRouter.navigate(route);
  }

  logout(): void {
    this.authService.logout();
    this.tenantRouter.logoutRedirect();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
